export default __webpack_public_path__ + "static/media/landscape_prep2.1f1fc756.jpg";